/**
 * Citizen Agent (Innbyggeragent) widget for search results.
 * Sends the search query to the Copilot Studio bot via DirectLine REST API
 * and displays the answer inline above search results.
 */
(function () {
    var widget = document.getElementById('citizenAgentWidget');
    if (!widget) return;

    var TOKEN_ENDPOINT = widget.getAttribute('data-token-endpoint');
    if (!TOKEN_ENDPOINT) return;

    var searchQuery = widget.getAttribute('data-query');
    var trackHitId = widget.getAttribute('data-track-hit-id');
    var analyticsId = widget.getAttribute('data-analytics-id');
    var promptPrefix = widget.getAttribute('data-prompt-prefix') || '';
    var promptSuffix = widget.getAttribute('data-prompt-suffix') || '';
    var answerEl = document.getElementById('citizenAgentAnswer');
    var showMoreBtn = document.getElementById('citizenAgentShowMore');

    if (!answerEl) return;

    // Helper: send interaction tracking beacon
    function trackInteraction(action) {
        if (analyticsId && navigator.sendBeacon) {
            navigator.sendBeacon('/api/search/track-interaction',
                new Blob([JSON.stringify({ analyticsId: analyticsId, action: action })],
                    { type: 'application/json' }));
        }
    }

    // Toggle show more / show less
    if (showMoreBtn) {
        var showMoreLabel = showMoreBtn.firstChild; // text node
        showMoreBtn.addEventListener('click', function () {
            var isClamped = answerEl.classList.contains('is-clamped');
            if (isClamped) {
                answerEl.style.maxHeight = answerEl.scrollHeight + 'px';
                answerEl.classList.remove('is-clamped');
                answerEl.classList.remove('has-overflow');
                showMoreBtn.classList.add('is-expanded');
                showMoreLabel.textContent = 'Vis mindre ';
                trackInteraction('showmore');
            } else {
                answerEl.classList.add('is-clamped');
                answerEl.classList.add('has-overflow');
                answerEl.style.maxHeight = '';
                showMoreBtn.classList.remove('is-expanded');
                showMoreLabel.textContent = 'Vis mer ';
            }
        });
    }

    if (!searchQuery) {
        answerEl.innerHTML = '';
        return;
    }

    // Build the full prompt: prefix + query + suffix
    var fullPrompt = searchQuery;
    if (promptPrefix) fullPrompt = promptPrefix + ' ' + fullPrompt;
    if (promptSuffix) fullPrompt = fullPrompt + ' ' + promptSuffix;

    function fetchRegionalAndToken() {
        var env = TOKEN_ENDPOINT.slice(0, TOKEN_ENDPOINT.indexOf("/powervirtualagents"));
        var ver = TOKEN_ENDPOINT.slice(TOKEN_ENDPOINT.indexOf("api-version")).split("=")[1];
        var regional = env + "/powervirtualagents/regionalchannelsettings?api-version=" + ver;

        return Promise.all([
            fetch(regional, { credentials: "omit" }),
            fetch(TOKEN_ENDPOINT, { credentials: "omit" })
        ]).then(function (results) {
            if (!results[0].ok) throw new Error("Regional request failed");
            if (!results[1].ok) throw new Error("Token request failed");

            return Promise.all([results[0].json(), results[1].json()]);
        }).then(function (data) {
            return {
                baseUrl: data[0].channelUrlsById.directline,
                token: data[1].token
            };
        });
    }

    // Simple markdown-ish to HTML: bold, links, references, line breaks
    function formatAnswer(text) {
        // Collect footnote-style references: [1]: https://url "title"
        var references = {};
        text = text.replace(/^\[(\d+)\]:\s*(https?:\/\/\S+)\s*"([^"]*)"?\s*$/gm, function (_, num, url, title) {
            references[num] = { url: url, title: title || url };
            return '';
        });
        // Also handle without quotes: [1]: https://url
        text = text.replace(/^\[(\d+)\]:\s*(https?:\/\/\S+)\s*$/gm, function (_, num, url) {
            if (!references[num]) references[num] = { url: url, title: url };
            return '';
        });

        // Replace inline [n] citations with clickable links
        text = text.replace(/\[(\d+)\]/g, function (_, num) {
            var ref = references[num];
            if (ref) return '<a href="' + ref.url + '" target="_blank" rel="noopener" class="citizen-agent-link">[' + num + ']</a>';
            return '[' + num + ']';
        });

        // Bold
        text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        // Inline links [text](url)
        text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener" class="citizen-agent-link">$1</a>');
        // Headers (### before ## before #)
        text = text.replace(/^### +(.+)$/gm, '<strong style="font-size:1em;">$1</strong>');
        text = text.replace(/^## +(.+)$/gm, '<strong style="font-size:1.05em;">$1</strong>');
        text = text.replace(/^# +(.+)$/gm, '<strong style="font-size:1.1em;">$1</strong>');

        // Unordered lists: consecutive lines starting with - or *
        text = text.replace(/((?:^[\-\*] .+$\n?)+)/gm, function (block) {
            var items = block.trim().split('\n').map(function (line) {
                return '<li>' + line.replace(/^[\-\*] /, '') + '</li>';
            }).join('');
            return '<ul class="citizen-agent-list">' + items + '</ul>';
        });

        // Ordered lists: consecutive lines starting with 1. 2. etc
        text = text.replace(/((?:^\d+\. .+$\n?)+)/gm, function (block) {
            var items = block.trim().split('\n').map(function (line) {
                return '<li>' + line.replace(/^\d+\. /, '') + '</li>';
            }).join('');
            return '<ol class="citizen-agent-list">' + items + '</ol>';
        });

        // Paragraphs and line breaks
        text = text.replace(/\n\n/g, '</p><p>');
        text = text.replace(/\n/g, '<br>');
        // Clean up empty paragraphs from removed references
        text = text.replace(/(<br>){2,}/g, '<br>');
        text = text.replace(/<p>\s*<\/p>/g, '');

        // Append sources list if we have references
        var refNums = Object.keys(references);
        if (refNums.length > 0) {
            text += '</p><div class="citizen-agent-widget__sources"><strong>Kilder:</strong><ul>';
            refNums.sort(function (a, b) { return a - b; }).forEach(function (num) {
                var ref = references[num];
                text += '<li><a href="' + ref.url + '" target="_blank" rel="noopener" class="citizen-agent-link">' + ref.title + '</a></li>';
            });
            text += '</ul></div><p>';
        }

        return text;
    }

    function delay(ms) {
        return new Promise(function (r) { setTimeout(r, ms); });
    }

    function getAnswer() {
        fetchRegionalAndToken().then(function (config) {
            var dlUrl = config.baseUrl + 'v3/directline';

            // 1. Start conversation
            return fetch(dlUrl + '/conversations', {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + config.token, 'Content-Type': 'application/json' }
            }).then(function (convRes) {
                if (!convRes.ok) throw new Error('Could not start conversation');
                return convRes.json();
            }).then(function (conv) {
                var convId = conv.conversationId;
                var convToken = conv.token;

                // 2. Send startConversation event (PVA pattern)
                return fetch(dlUrl + '/conversations/' + convId + '/activities', {
                    method: 'POST',
                    headers: { 'Authorization': 'Bearer ' + convToken, 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        type: 'event',
                        name: 'startConversation',
                        from: { id: 'user' },
                        locale: 'nb-NO',
                        channelData: { ui: 'search-widget', version: '1.0.0' }
                    })
                }).then(function () {
                    return delay(500);
                }).then(function () {
                    // 3. Send search query (with prompt prefix/suffix)
                    return fetch(dlUrl + '/conversations/' + convId + '/activities', {
                        method: 'POST',
                        headers: { 'Authorization': 'Bearer ' + convToken, 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            type: 'message',
                            text: fullPrompt,
                            from: { id: 'user' },
                            locale: 'nb-NO'
                        })
                    });
                }).then(function () {
                    // 4. Poll for bot response (max ~30 seconds)
                    var watermark = '';
                    var botMessages = [];
                    var attempts = 0;
                    var maxAttempts = 30;

                    function poll() {
                        if (attempts >= maxAttempts) {
                            if (botMessages.length === 0) {
                                answerEl.innerHTML = '<div class="citizen-agent-widget__error">Fikk ikke svar fra AI-assistenten.</div>';
                            } else {
                                showAnswer(botMessages);
                            }
                            return;
                        }

                        return delay(1000).then(function () {
                            attempts++;
                            var pollUrl = dlUrl + '/conversations/' + convId + '/activities';
                            if (watermark) pollUrl += '?watermark=' + watermark;

                            return fetch(pollUrl, {
                                headers: { 'Authorization': 'Bearer ' + convToken }
                            });
                        }).then(function (pollRes) {
                            if (!pollRes.ok) return poll();
                            return pollRes.json();
                        }).then(function (pollData) {
                            if (pollData.watermark) watermark = pollData.watermark;

                            var activities = pollData.activities || [];
                            for (var i = 0; i < activities.length; i++) {
                                var a = activities[i];
                                if (a.type === 'message' && a.from && a.from.role === 'bot' && a.text) {
                                    botMessages.push(a.text);
                                }
                            }

                            if (botMessages.length >= 2) {
                                showAnswer(botMessages);
                                return;
                            }

                            return poll();
                        });
                    }

                    return poll();
                });
            });
        }).catch(function (err) {
            console.error('Citizen agent error:', err);
            answerEl.innerHTML = '<div class="citizen-agent-widget__error">Kunne ikke hente svar. Prøv igjen senere.</div>';
        });
    }

    function showAnswer(botMessages) {
        var answer = botMessages[botMessages.length - 1];
        answerEl.innerHTML = '<p>' + formatAnswer(answer) + '</p>';

        // Track clicks on links inside the agent answer (all click types)
        answerEl.querySelectorAll('a.citizen-agent-link').forEach(function (link) {
            link.addEventListener('mousedown', function (e) { if (e.button === 0 || e.button === 1) trackInteraction('agentlink'); });
            link.addEventListener('contextmenu', function () { trackInteraction('agentlink'); });
        });

        // Show feedback buttons
        var feedbackEl = document.getElementById('citizenAgentFeedback');
        if (feedbackEl) {
            feedbackEl.style.display = '';
            feedbackEl.querySelectorAll('.citizen-agent-widget__feedback-btn').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var isHelpful = this.getAttribute('data-helpful') === 'yes';
                    trackInteraction(isHelpful ? 'helpful_yes' : 'helpful_no');
                    this.classList.add('is-selected');
                    // Disable both buttons and show thanks
                    feedbackEl.querySelectorAll('.citizen-agent-widget__feedback-btn').forEach(function (b) {
                        b.disabled = true;
                        if (!b.classList.contains('is-selected')) b.style.opacity = '0.4';
                    });
                    var thanks = document.createElement('span');
                    thanks.className = 'citizen-agent-widget__feedback-thanks';
                    thanks.textContent = 'Takk for tilbakemeldingen!';
                    feedbackEl.querySelector('.citizen-agent-widget__feedback-label').textContent = '';
                    feedbackEl.appendChild(thanks);
                });
            });
        }

        // Answer starts unclamped. After render, check if it exceeds the clamp height (176px).
        // If so, add the clamp + gradient + "Vis mer". Otherwise leave it as-is.
        requestAnimationFrame(function () {
            var CLAMP_HEIGHT = 176;
            var fullHeight = answerEl.scrollHeight;
            if (fullHeight > CLAMP_HEIGHT + 10) {
                answerEl.classList.add('is-clamped');
                answerEl.classList.add('has-overflow');
                if (showMoreBtn) showMoreBtn.style.display = 'flex';
            }
        });

        // Track as a relevant hit in EPiServer Find statistics
        // so "searches without relevant hits" isn't inflated by AI-only interactions
        if (trackHitId && searchQuery && navigator.sendBeacon) {
            navigator.sendBeacon('/api/search/track-click',
                new Blob([JSON.stringify({ hitId: trackHitId, query: searchQuery })],
                    { type: 'application/json' }));
        }

        // Log AI answer to search analytics
        if (analyticsId && answer && navigator.sendBeacon) {
            navigator.sendBeacon('/api/search/track-ai-answer',
                new Blob([JSON.stringify({ analyticsId: analyticsId, answer: answer })],
                    { type: 'application/json' }));
        }
    }

    getAnswer();
})();
